import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { UserForAuthentication, UserPhoneLogin } from 'src/app/interfaces/user/UserForAuthenticatio.model';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { TokenStorageService } from '../../_services/token-storage.service';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { emailValidator } from 'src/app/theme/utils/app-validators';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'login-user',
  templateUrl: './login-user.component.html',
  styleUrls: ['./login-user.component.scss']
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  public phoneLoginFrom: FormGroup;
  public errorMessage: string = '';
  public showError: boolean;
  private _returnUrl: string;
  isLoggedIn = false;
  role: string = '';
  toggle: boolean = true;
  public mobileNumber: string;


  constructor(private _authService: AuthenticationService, public appService: AppService, private _router: Router,
    private _route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private tokenStorage: TokenStorageService) { }

  ngOnInit(): void {
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.role = this.tokenStorage.getUser().role;
      this._router.routeReuseStrategy.shouldReuseRoute = () => false;
      this._router.onSameUrlNavigation = 'reload';
      if (this.role.toLowerCase() != 'admin')
        this._router.navigate(['/home']);
      else
        this._router.navigate(['/admin/products']);

    }

    this.loginForm = new FormGroup({
      email: new FormControl("", Validators.compose([Validators.required, emailValidator])),
      password: new FormControl("", [Validators.required, Validators.minLength(6)])
    })

    this.phoneLoginFrom = new FormGroup({
      otp: new FormControl("", [Validators.minLength(6)]),
      mobileNumber: new FormControl("", [Validators.required, Validators.maxLength(10), Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")])
    })

    this._returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
  }
  toggleView(change: MatButtonToggleChange) {
    this.toggle = change.value;
  }

  public validateControl = (controlName: string) => {
    return this.loginForm.controls[controlName].invalid && this.loginForm.controls[controlName].touched
  }
  public hasError = (controlName: string, errorName: string) => {
    return this.loginForm.controls[controlName].hasError(errorName)
  }


  public phoneUser = (mobileloginFormValue) => {
    this.showError = false;
    const loginPhone = { ...mobileloginFormValue };
    const userForAuthPhone: UserPhoneLogin = {
      otp: loginPhone.otp,
      mobileNumber: loginPhone.mobileNumber
    }

    if (userForAuthPhone.otp == '' || userForAuthPhone.otp == undefined) {


      this._authService.getOTP(`api/Login/MobileUserAuthenticate?mobileNumber=${userForAuthPhone.mobileNumber}`, {}).subscribe(data => {
        this.snackBar.open("OTP send successfully.", '×', { panelClass: 'sucess', verticalPosition: 'top', duration: 3000 });

      }, (error) => {

        if (error.error.text != undefined) {
          this.snackBar.open("OTP send successfully.", '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
        }
        else {
          this.snackBar.open(error.error, '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
        }
      });
    }
    else {
      if (this.phoneLoginFrom.valid) {
        this._authService.verifyOTP(`api/Login/VerifyOtp?OTP=${userForAuthPhone.otp}&mobileNumber=${userForAuthPhone.mobileNumber}`, userForAuthPhone)
          .subscribe(res => {
            this.tokenStorage.saveToken(res.token);
            this.tokenStorage.saveUser(res);
            this.isLoggedIn = true;
            this.role = this.tokenStorage.getUser().role;

            this._authService.sendAuthStateChangeNotification(res.isAuthSuccessful);
            this._router.routeReuseStrategy.shouldReuseRoute = () => false;
            this._router.onSameUrlNavigation = 'reload';
            if (this.role.toLowerCase() != 'admin')
              this._router.navigate(['/home']);
            else
              this._router.navigate(['/admin/products']);
          },
            (error) => {
              this.snackBar.open(error.error, '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
            })
      }
      else {
        this.snackBar.open("Please enter valid mobile number/OTP.", '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });

      }
    }

  }

  public loginUser = (loginFormValue) => {
    this.showError = false;
    const login = { ...loginFormValue };
    const userForAuth: UserForAuthentication = {
      email: login.email,
      password: login.password
    }
    if (this.loginForm.valid) {
      this._authService.loginUser('api/login/authenticate', userForAuth)
        .subscribe(res => {

          this.tokenStorage.saveToken(res.token);
          this.tokenStorage.saveUser(res);
          this.isLoggedIn = true;
          this.role = this.tokenStorage.getUser().role;

          this._authService.sendAuthStateChangeNotification(res.isAuthSuccessful);
          this._router.routeReuseStrategy.shouldReuseRoute = () => false;
          this._router.onSameUrlNavigation = 'reload';
          if (this.role.toLowerCase() != 'admin')
            this._router.navigate(['/home']);
          else
            this._router.navigate(['/admin/products']);
        },
          (error) => {
            this.snackBar.open(error.error, '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
          })
    }
    else {
      this.snackBar.open("Please enter valid email/password.", '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
    }
  }
}